import { Badge } from '@/components/ui/badge';
import { formatRelative } from '@/lib/time';
import type { StoreRevision } from '@/lib/revision-queue';

// Store statuses where the store is no longer selling (mirrors the ARCHIVED
// set in routes/StorePage.tsx, plus the other terminal statuses seen live on
// teamStores) — de-emphasize them here rather than let a closed/archived
// store's request look live.
const DEEMPHASIZED_STORE_STATUSES = [
  'closed', 'ended', 'archived', 'archived_failed', 'archived_duplicate', 'superseded', 'rejected', 'test_complete',
];

// A team-store row in the merged Revisions queue. Like RevisionRow for prizes,
// the customer's words are IN the row — the queue is readable without opening
// anything.
export function StoreRevisionRow({ r, onClick }: { r: StoreRevision; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="flex w-full items-center gap-3 border-b border-divider px-3 py-2 text-left hover:bg-bg/60 last:border-b-0"
    >
      <Badge className="w-12 justify-center bg-primary/10 text-primary">Store</Badge>
      <span className="flex-1 truncate text-[12px]" title={r.notes || r.detailSummary || undefined}>
        {r.storeName}
        {(r.notes || r.detailSummary) && <span className="ml-2 text-muted">— {r.notes || r.detailSummary}</span>}
      </span>
      {r.fileCount > 0 ? (
        <Badge className="bg-bg text-muted">{r.fileCount} file{r.fileCount === 1 ? '' : 's'}</Badge>
      ) : null}
      {r.storeStatus && DEEMPHASIZED_STORE_STATUSES.includes(r.storeStatus) ? (
        <Badge className="bg-bg text-muted">{r.storeStatus.replace('_', ' ')}</Badge>
      ) : null}
      <Badge className="bg-warning/10 text-warning">{r.source === 'proof_page' ? 'Customer proof' : 'Rep request'}</Badge>
      <span className="w-12 shrink-0 text-right text-[11px] text-muted">
        {r.requestedAt ? formatRelative(r.requestedAt) : ''}
      </span>
    </button>
  );
}
